import packageInfo from '../../../../package.json';

export const FLEET_VERSION = packageInfo.version;
